<shared-subheader></shared-subheader>
<div class="content-container">
    <app-event-list-actions-bar></app-event-list-actions-bar>
</div>
<app-event-list></app-event-list>
